import { PredefinedCommentValidationContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/contexts/predefined-comment-validation-form.context';
import { PredefinedCommentFormValidity } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import { initialPredefinedCommentFormValidity } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.constants';
import React, { useCallback, useState } from 'react';

interface PredefinedCommentValidationProviderProps {
    children: React.ReactNode;
}

export const PredefinedCommentValidationProvider: React.FC<PredefinedCommentValidationProviderProps> = ({
    children,
}) => {
    const [validity, setValidity] = useState<PredefinedCommentFormValidity>(
        structuredClone(initialPredefinedCommentFormValidity)
    );

    const handleError = useCallback(
        (
            field: keyof PredefinedCommentFormValidity,
            newValidity: PredefinedCommentFormValidity[keyof PredefinedCommentFormValidity]
        ) => {
            setValidity((prevState) => ({
                ...prevState,
                [field]: newValidity,
            }));
        },
        []
    );

    const setApiErrors = useCallback((errors: PredefinedCommentFormValidity) => {
        setValidity((prevState) => ({
            ...prevState,
            ...errors,
        }));
    }, []);

    const value = React.useMemo(() => ({ validity, handleError, setApiErrors }), [validity, handleError, setApiErrors]);

    return (
        <PredefinedCommentValidationContext.Provider value={value}>
            {children}
        </PredefinedCommentValidationContext.Provider>
    );
};
